import React from "react";
import { Outlet } from "react-router-dom";
import AdminNavbar from "./AdminNavbar";
import AdminSidebar from "./AdminSidebar";
import "./adminlayout.css";

export default function AdminLayout() {
  return (
    <div className="dashboard" data-layout="dashboard">
      {/* Persistent admin sidebar on every page */}
      <AdminSidebar />

      {/* Right side: navbar + page content */}
      <div className="content-area">
        <AdminNavbar />
        <main className="main" data-layout="main">
          <div className="container-fluid" data-layout="container">
            {/* Child route content (AdminDashboard, Companies, Users, etc.) renders here */}
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
